import "./LibrariesImport";

// SmoothScroll has to be first
import SmoothScroll from "./animations/SmoothScroll";

import ResizeEvents from "./events/ResizeEvents";
import EventListeners from "./events/EventListeners";
import LazyLoadImages from "./events/ImageLoaded";

import MobileCheck from "./utils/MobileCheck";
import DevHelpers from "./utils/DevHelpers";

import Buttons from "./components/Buttons";
import Gallery from "./components/Gallery";
import RichText from "./components/RichText";

import AppearOnScroll from "./data-attributes/AppearOnScroll";
import DataBatch from "./data-attributes/DataBatch";
import DataLink from "./data-attributes/DataLink";
import MatchHeight from "./data-attributes/MatchHeight";
import Parallax from "./data-attributes/Parallax";
import TextAppear from "./data-attributes/TextAppear";
import Split from "./data-attributes/Split";

LazyLoadImages.init();

export default class StarterKit {
	static init() {
		SmoothScroll.init();

		ResizeEvents.init();
		EventListeners.init();

		MobileCheck.init();
		DevHelpers.init();

		AppearOnScroll.init();
		DataBatch.init();
		DataLink.init();
		MatchHeight.init();
		Parallax.init();
		Split.init();
		TextAppear.init();
		Buttons.init();
		RichText.init();
		Gallery.init();
	}
}
